import { render, staticRenderFns } from "./AssessmentOptions.vue?vue&type=template&id=61d623d4"
import script from "./AssessmentOptions.vue?vue&type=script&lang=js"
export * from "./AssessmentOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports